module.exports = __webpack_public_path__ + "static/media/21ECLAC5.1d3643cd.jpg";